export const LESSON_EDIT_BAR_ELEMENT_ID = 'lesson-edit-bar';
export const CHUNK_ELEMENT_ID = 'chunk';

export enum DRAFTJS_BLOCK {
  unstyled = 'unstyled',
  codeblock = 'code-block',
  blockquote = 'blockquote',
}
